var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17432 18.8638V21.1138",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6743 18.8638V21.1138",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67432 10.6138V5.73877C5.67432 5.24149 5.87186 4.76458 6.22349 4.41294C6.57512 4.06131 7.05204 3.86377 7.54932 3.86377C8.0466 3.86377 8.52351 4.06131 8.87514 4.41294C9.22677 4.76458 9.42432 5.24149 9.42432 5.73877",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1743 9.86377H13.1743V14.3638H19.1743V9.86377Z",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1743 10.6138H22.1743C22.3732 10.6138 22.564 10.6928 22.7046 10.8334C22.8453 10.9741 22.9243 11.1649 22.9243 11.3638V14.3638C22.9243 15.5572 22.4502 16.7018 21.6063 17.5458C20.7624 18.3897 19.6178 18.8638 18.4243 18.8638H6.42432C5.23084 18.8638 4.08625 18.3897 3.24234 17.5458C2.39842 16.7018 1.92432 15.5572 1.92432 14.3638V11.3638C1.92432 11.1649 2.00333 10.9741 2.14399 10.8334C2.28464 10.6928 2.4754 10.6138 2.67432 10.6138H13.1743",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.f8a735273ec1ac5cd8131d9d6389c37e.svg";
export { ForwardRef as ReactComponent };